"use strict";
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _AbstractTreeNodeData_id, _AbstractTreeNodeData_uuidGenerator, _AbstractTreeNodeData_convertedObject, _AbstractTreeNodeData_updateCallbackConvertedObject, _AbstractTreeNodeData_version, _AbstractTreeNodeData_updateCallback;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractTreeNodeData = void 0;
const viewer_shared_services_1 = require("@shapediver/viewer.shared.services");
class AbstractTreeNodeData {
    // #endregion Properties (5)
    // #region Constructors (1)
    /**
     * Creates a tree node data object.
     *
     * @param id Id of this data object
     */
    constructor(id, version) {
        // #region Properties (5)
        _AbstractTreeNodeData_id.set(this, void 0);
        _AbstractTreeNodeData_uuidGenerator.set(this, viewer_shared_services_1.UuidGenerator.instance);
        _AbstractTreeNodeData_convertedObject.set(this, {});
        _AbstractTreeNodeData_updateCallbackConvertedObject.set(this, null);
        _AbstractTreeNodeData_version.set(this, void 0);
        _AbstractTreeNodeData_updateCallback.set(this, null);
        __classPrivateFieldSet(this, _AbstractTreeNodeData_id, id || __classPrivateFieldGet(this, _AbstractTreeNodeData_uuidGenerator, "f").create(), "f");
        __classPrivateFieldSet(this, _AbstractTreeNodeData_version, version || __classPrivateFieldGet(this, _AbstractTreeNodeData_uuidGenerator, "f").create(), "f");
    }
    // #endregion Constructors (1)
    // #region Public Getters And Setters (6)
    get convertedObject() {
        return __classPrivateFieldGet(this, _AbstractTreeNodeData_convertedObject, "f");
    }
    set convertedObject(value) {
        __classPrivateFieldSet(this, _AbstractTreeNodeData_convertedObject, value, "f");
    }
    get id() {
        return __classPrivateFieldGet(this, _AbstractTreeNodeData_id, "f");
    }
    get updateCallback() {
        return __classPrivateFieldGet(this, _AbstractTreeNodeData_updateCallback, "f");
    }
    set updateCallback(value) {
        __classPrivateFieldSet(this, _AbstractTreeNodeData_updateCallback, value, "f");
    }
    get updateCallbackConvertedObject() {
        return __classPrivateFieldGet(this, _AbstractTreeNodeData_updateCallbackConvertedObject, "f");
    }
    set updateCallbackConvertedObject(value) {
        __classPrivateFieldSet(this, _AbstractTreeNodeData_updateCallbackConvertedObject, value, "f");
    }
    get version() {
        return __classPrivateFieldGet(this, _AbstractTreeNodeData_version, "f");
    }
    // #endregion Public Getters And Setters (6)
    // #region Public Methods (2)
    /**
     * Clones the tree node data.
     */
    clone() {
        const clone = new this.constructor();
        return clone;
    }
    /**
     * Update the version
     */
    updateVersion() {
        const oldVersion = __classPrivateFieldGet(this, _AbstractTreeNodeData_version, "f");
        __classPrivateFieldSet(this, _AbstractTreeNodeData_version, __classPrivateFieldGet(this, _AbstractTreeNodeData_uuidGenerator, "f").create(), "f");
        if (__classPrivateFieldGet(this, _AbstractTreeNodeData_updateCallback, "f"))
            __classPrivateFieldGet(this, _AbstractTreeNodeData_updateCallback, "f").call(this, __classPrivateFieldGet(this, _AbstractTreeNodeData_version, "f"), oldVersion);
    }
}
exports.AbstractTreeNodeData = AbstractTreeNodeData;
_AbstractTreeNodeData_id = new WeakMap(), _AbstractTreeNodeData_uuidGenerator = new WeakMap(), _AbstractTreeNodeData_convertedObject = new WeakMap(), _AbstractTreeNodeData_updateCallbackConvertedObject = new WeakMap(), _AbstractTreeNodeData_version = new WeakMap(), _AbstractTreeNodeData_updateCallback = new WeakMap();
//# sourceMappingURL=AbstractTreeNodeData.js.map